import OperatorLogo, { OperatorName } from './OperatorLogo';
import styles from '../styles/ActiveOperators.module.scss';

interface ActiveOperatorsProps {
    activeOperators: OperatorName[];
    locationName: string;
}

function ActiveOperators({
    activeOperators,
    locationName,
}: ActiveOperatorsProps) {
    if (activeOperators.length === 0) {
        return null;
    }

    return (
        <div className={styles.activeOperatorsContainer}>
            <span className={styles.activeOperatorText}>
                Active Operators in {locationName}
            </span>
            <div className={styles.operatorLogoContainer}>
                {activeOperators
                    .sort((a, b) => a.localeCompare(b))
                    .map(name => (
                        <div key={name} className={styles.operatorLogo}>
                            <OperatorLogo operator={name as OperatorName} />
                        </div>
                    ))}
            </div>
        </div>
    );
}

export default ActiveOperators;
